import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { BusinessAuthService } from '../services/business-auth.service';

/**
 * Guard para rutas de "invitado" (ej. login).
 * Si ya hay sesión en el área empresas, redirige al panel.
 */
export const businessGuestGuard: CanActivateFn = () => {
  const auth = inject(BusinessAuthService);

  if (auth.isLoggedIn()) {
    if (auth.needsMasterCompanySelection()) {
      window.location.replace('/empresas/elegir-empresa');
    } else {
      window.location.replace('/empresas/panel');
    }
    return false;
  }
  return true;
};
